namespace AgerLMS.Administration {
    export namespace PermissionKeys {
        export const Security = "Administration:Security";
        export const Translation = "Administration:Translation";
        export const SiteSetting = "Administration:SiteSetting:";
        export const SiteSettingRead = "Administration:SiteSetting:Read";
        export const SiteSettingModify = "Administration:SiteSetting:Modify";
        export const SiteSettingPage = "Administration:SiteSetting:Page";
        export const User = "Administration:User:";
        export const UserRead = "Administration:User:Read";
        export const UserInsert = "Administration:User:Insert";
        export const UserUpdate = "Administration:User:Update";
        export const UserDelete = "Administration:User:Delete";
        export const UserPage = "Administration:User:Page";
        export const WebSiteUserPage = "Administration:User:WebSiteUserPage";
        export const StudentUserPage = "Administration:User:StudentPage";
        export const InstructorUserPage = "Administration:User:InstructorPage";
        export const StudentUpdateProfilePage = "Administration:User:StudentUpdateProfilePage";
        export const Role = "Administration:Role:";
        export const RoleRead = "Administration:Role:Read";
        export const RoleInsert = "Administration:Role:Insert";
        export const RoleUpdate = "Administration:Role:Update";
        export const RoleDelete = "Administration:Role:Delete";
        export const RolePage = "Administration:Role:Page";
        export const UserRole = "Administration:UserRole:";
        export const UserRoleRead = "Administration:UserRole:Read";
        export const UserRoleInsert = "Administration:UserRole:Insert";
        export const UserRoleUpdate = "Administration:UserRole:Update";
        export const UserRoleDelete = "Administration:UserRole:Delete";
        export const UserRolePage = "Administration:UserRole:Page";
        export const UserPermission = "Administration:UserPermission:";
        export const UserPermissionRead = "Administration:UserPermission:Read";
        export const UserPermissionInsert = "Administration:UserPermission:Insert";
        export const UserPermissionUpdate = "Administration:UserPermission:Update";
        export const UserPermissionDelete = "Administration:UserPermission:Delete";
        export const UserPermissionPage = "Administration:UserPermission:Page";
        export const RolePermission = "Administration:RolePermission:";
        export const RolePermissionRead = "Administration:RolePermission:Read";
        export const RolePermissionInsert = "Administration:RolePermission:Insert";
        export const RolePermissionUpdate = "Administration:RolePermission:Update";
        export const RolePermissionDelete = "Administration:RolePermission:Delete";
        export const RolePermissionPage = "Administration:RolePermission:Page";
    }
}
